<div class="selector-container">
    <mat-button-toggle-group class="more-options-selector" [value]=optionSelected().id  [ngModel]="optionSelected" (ngModelChange)="optionSelected.set($event)" aria-label="Favorite Color">
        <ng-container *ngFor="let option of moreOptionsSelector">
            <mat-button-toggle [ngClass]="optionSelected().id === option.id ? 'toggle-active' : ''" [value]="option" class="toggle-button">
                <div class="toggle-button-content-container">
                    <mat-icon [svgIcon]="option.id"></mat-icon>
                    <span>{{option.label | transloco}}</span>
                </div>
            </mat-button-toggle>
        </ng-container>
    </mat-button-toggle-group>
    <ng-container [ngSwitch]="optionSelected().id">
        <ng-container *ngSwitchCase="busId">
            <div class="tab-container">
                <app-bus-form [itineraryType]="itineraryType" [combinedWith]="'walk'" [wheelchairAccessible]="wheelcharAccessible" [maxWalkTime]="maxWalkTimeOnBusItinerary" [walkSpeed]="walkSpeed"></app-bus-form>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="walkId">
            <div class="tab-container">
                <app-walk-form [walkSpeed]="walkSpeed" [wheelchairAccessible]="wheelcharAccessible"></app-walk-form>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="bicycleId">
            <div class="tab-container">
                <app-bicycle-form [flat]="flat" [fast]="fast" [bicycleAdapted]="bicycleAdapted" [resetObservable]="resetObservable"></app-bicycle-form>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="allId">
            <div class="tab-container">
                <app-bus-form [itineraryType]="itineraryType" [combinedWith]="'bicycle'" [maxWalkTime]="maxWalkTimeOnMultimodal" [walkSpeed]="bikeSpeed"></app-bus-form>
                <app-bicycle-form [flat]="flat" [fast]="fast" [bicycleAdapted]="bicycleAdapted" [resetObservable]="resetObservable"></app-bicycle-form>
            </div>
        </ng-container>
    </ng-container>
</div>